import {CApi as userGwApi} from '@services/api';

const readOfferUrl = (data: unknown): string | null => {
    if (!data || typeof data !== 'object' || !('url' in data)) {
        return null;
    }

    const {url} = data as {url: unknown};

    return typeof url === 'string' && url ? url : null;
};

let pendingOpen: Promise<void> | null = null;

export const openActualOffer = (): Promise<void> => {
    if (pendingOpen) {
        return pendingOpen;
    }

    const popup = window.open('about:blank', '_blank');

    pendingOpen = (async () => {
        try {
            const response = await userGwApi().actualOffer.actualOfferList();
            const url = readOfferUrl(response.data);

            if (!url) {
                popup?.close();
                console.error('В ответе actualOffer нет ссылки на документ');
                return;
            }

            if (popup && !popup.closed) {
                popup.opener = null;
                popup.location.replace(url);
                return;
            }

            window.open(url, '_blank', 'noopener,noreferrer');
        } catch (error) {
            popup?.close();
            console.error('Ошибка при получении оферты:', error);
        } finally {
            pendingOpen = null;
        }
    })();

    return pendingOpen;
};